import axios from 'axios';

import { environment } from '@environments/environment';
import { addKeycloakInterceptor } from '@tsl-frontend/tsl-axios';

const curriculumGateway = axios.create({
    baseURL: environment.curriculumCmsApiUrl,
    withCredentials: true,
});

addKeycloakInterceptor(curriculumGateway);

export { curriculumGateway };
